module.exports = __webpack_public_path__ + "img/cp-event-current.822190ae.svg";